import React from 'react';
import EditProgressModal from './EditProgressModal';
import type { OrderProgressCreatedItem } from '../models/OrderProgressModel';

type ProgressFormItem = {
  id?: string;
  date: string;
  employee_ids: string[];
  employee_names?: string[];
  note: string;
  order_id?: string;
  order_code?: string;
  customer_name?: string;
  sales_employee_name?: string;
  delivery_address_line?: string;
  created_at?: string;
  updated_at?: string;
  created_by_name?: string;
  updated_by_name?: string;
};

export interface NewOrderProgressProps {
  mode?: 'create' | 'edit';
  item?: ProgressFormItem | null;
  onCancel?: () => void;
  onUpdate?: () => void;
  onItemCreated?: (createdItem: OrderProgressCreatedItem) => void;
  onSuccess?: (message: string) => void;
  disabled?: boolean;
  tabId?: number;
  isActive?: boolean;
  onUnsavedChanges?: (hasChanges: boolean, tabId?: number) => void;
  activeCompanyFilter?: string;
}

const NewOrderProgress: React.FC<NewOrderProgressProps> = ({
  mode = 'create',
  item = null,
  onCancel,
  onUpdate,
  onItemCreated,
  onSuccess,
  disabled = false,
  tabId,
  isActive = true,
  onUnsavedChanges,
  activeCompanyFilter,
}) => (
  <EditProgressModal
    embedded
    open
    isActive={isActive}
    tabId={tabId}
    onUnsavedChanges={onUnsavedChanges}
    onClose={() => onCancel?.()}
    item={item}
    onUpdate={onUpdate}
    onItemCreated={onItemCreated}
    onSuccess={onSuccess}
    mode={mode}
    disabled={disabled}
    activeCompanyFilter={activeCompanyFilter}
  />
);

export default NewOrderProgress;
